import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/task',
    name: 'Task',
    component: () => import('@/views/task/index.vue')
  },
  {
    path: '/organization',
    name: 'Organization',
    component: () => import('@/views/organization/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
